import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/api/axios";
import { Card, CardContent } from "@/components/ui/card";
import { CheckCircle, XCircle, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [status, setStatus] = useState<"loading" | "success" | "error">(() =>
    token ? "loading" : "error"
  );
  const [message, setMessage] = useState(() =>
    token ? "" : "Токен не найден в ссылке"
  );

  useEffect(() => {
    if (!token) return;
    api.get(`/api/auth/verify-email/${token}`)
      .then((res) => {
        if (res.data.success) {
          setStatus("success");
          setMessage("Email успешно подтверждён!");
        } else {
          setStatus("error");
          setMessage(res.data.error || "Недействительная или просроченная ссылка");
        }
      })
      .catch(() => {
        setStatus("error");
        setMessage("Ошибка проверки ссылки");
      });
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 p-4">
      <Card className="w-full max-w-md border-slate-700 bg-slate-900/80 backdrop-blur text-center">
        <CardContent className="p-8 space-y-4">
          {status === "loading" && (
            <Loader2 className="h-10 w-10 animate-spin mx-auto text-primary" />
          )}
          {status === "success" && (
            <CheckCircle className="h-12 w-12 mx-auto text-emerald-400" />
          )}
          {status === "error" && (
            <XCircle className="h-12 w-12 mx-auto text-red-400" />
          )}
          <p className="text-lg text-white">{message || "Проверка ссылки..."}</p>
          {status !== "loading" && (
            <Link to="/login">
              <Button variant="outline" className="border-slate-700 mt-2">
                Войти в систему
              </Button>
            </Link>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
